import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { User } from '@adornis/buchungsheld-db/entities/user.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { _subscribeCurrentUser, currentUser, updateCurrentUser } from '@adornis/users/client/currentUser.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { filter, firstValueFrom } from 'rxjs';

@customElement('bh-page-action-login')
export class BHPageActionLogin extends BuchungsheldLitElement {
  @state() private readonly _token = new RXController(
    this,
    routingState.searchParams.get('token').pipe(filter(Boolean)),
  );
  @state() _invalidToken = false;

  override render() {
    if (this._token.isLoading) {
      return html` <tr-loading-state></tr-loading-state> `;
    }

    if (!this._token.value || this._invalidToken) {
      return html`
        <tr-flex h100 w100 center crossaxis-center>
          <tr-card>
            <tr-flex space="md"> ${this._translation.translate('actions', 'invalid_link')} </tr-flex>
            <tr-button href="/"> ${this._translation.translate('actions', 'to_homepage')} </tr-button>
          </tr-card>
        </tr-flex>
      `;
    }

    void XDialog.waitFor(
      User.loginWithToken(this._token.value)()
        .then(async ([userID, userClass]) => {
          updateCurrentUser(undefined, false);
          await _subscribeCurrentUser({ userID, userClass });
        })
        .then(() => firstValueFrom(currentUser().whenReady.pipe(filter(Boolean))))
        .then(() => goTo('/profile'))
        .catch(() => {
          this._invalidToken = true;
        }),
    );

    return html`
      <tr-card>
        <tr-h4>${this._translation.translate('actions', 'getting_logged_in')}</tr-h4>
      </tr-card>
    `;
  }
}
